import type { Building } from "./types";

// Import all media files
import W1Image from "./components/W1.jpeg";
import W2Image from "./components/W2.jpeg";
import W3Image from "./components/W3.jpeg";
import W4Image from "./components/W4.jpeg";
import W5Image from "./components/W5.jpeg";
import SC1Image from "./components/SC1.jpeg";
import SC2Image from "./components/SC2.jpeg";
import SC3Video from "./components/SC3.MOV";
import T1Image from "./components/T1.jpeg";
import T2Image from "./components/T2.jpeg";
import T3Image from "./components/T3.jpeg";
import T4Image from "./components/T4.jpeg";
import T5Image from "./components/T5.jpeg";
import T6Image from "./components/T6.jpeg";
import V1Image from "./components/V1.jpeg";
import V2Image from "./components/V2.jpeg";
import V3Image from "./components/V3.jpeg";
import V4Image from "./components/V4.jpeg";
import P1Image from "./components/P1.jpeg";
import P2Image from "./components/P2.jpeg";
import P3Video from "./components/P3.MOV";
import P4Image from "./components/P4.jpeg";
import P5Image from "./components/P5.jpeg";
import P6Image from "./components/P6.jpeg";
// SF Fun images
import SF1Image from "./components/SF1.jpeg";
import SF2Image from "./components/SF2.jpeg";
import SF3Image from "./components/SF3.jpeg";
import SF4Image from "./components/SF4.jpeg";
import SF5Image from "./components/SF5.jpeg";
import SF6Image from "./components/SF6.jpeg";
import SF7Image from "./components/SF7.jpeg";
import SF8Image from "./components/SF8.jpeg";
import SF9Image from "./components/SF9.jpeg";
import SF10Image from "./components/SF10.jpeg";
// Coachella images
import C1Image from "./components/C1.jpeg";
import C2Image from "./components/C2.jpeg";
import C3Image from "./components/C3.jpeg";
import C4Image from "./components/C4.jpeg";
import CL1Image from "./components/CL1.jpeg";
import CL2Image from "./components/CL2.jpeg";
import CL3Image from "./components/CL3.jpeg";
import CL4Image from "./components/CL4.jpeg";
import CL5Image from "./components/CL5.jpeg";
import CL6Image from "./components/CL6.jpeg";
import CL7Image from "./components/CL7.jpeg";
import CL8Image from "./components/CL8.jpeg";
import CL9Image from "./components/CL9.jpeg";
import CL10Image from "./components/CL10.jpeg";
import CL11Image from "./components/CL11.jpeg";
import CL12Image from "./components/CL12.jpeg";
import CL13Video from "./components/CL13.MOV";
import CL14Image from "./components/CL14.jpeg";
import CL15Image from "./components/CL15.jpeg";
import CL16Image from "./components/CL16.jpeg";
import CL17Image from "./components/CL17.jpeg";
// Hawaii images
import H1Image from "./components/H1.jpeg";
import H2Image from "./components/H2.jpeg";
import H3Image from "./components/H3.jpeg";
import H4Image from "./components/H4.jpeg";
import H5Image from "./components/H5.jpeg";
import H6Image from "./components/H6.jpeg";
import H7Image from "./components/H7.jpeg";
import H8Image from "./components/H8.jpeg";
import H9Image from "./components/H9.jpeg";
import H10Image from "./components/H10.jpeg";
import H11Video from "./components/H11.MP4";
// Random Adventures images
import R1Image from "./components/R1.jpeg";
import R2Image from "./components/R2.jpeg";
import R3Image from "./components/R3.jpeg";
import R4Image from "./components/R4.jpeg";
import R5Image from "./components/R5.jpeg";
import R6Image from "./components/R6.jpeg";
import R7Image from "./components/R7.jpeg";
import R8Image from "./components/R8.jpeg";
// Pacifica images (using B series)
import B1Image from "./components/B1.jpeg";
import B2Image from "./components/B2.jpeg";
import B3Image from "./components/B3.jpeg";
import B4Image from "./components/B4.jpeg";
import B5Image from "./components/B5.jpeg";
import B6Image from "./components/B6.jpeg";
import B7Image from "./components/B7.jpeg";
// SS images
import SS1Image from "./components/SS1.jpeg";
import SS2Image from "./components/SS2.jpeg";
import SS3Image from "./components/SS3.jpeg";
import SS4Image from "./components/SS4.jpeg";
import SS5Image from "./components/SS5.jpeg";
import SS6Image from "./components/SS6.jpeg";
import SS7Image from "./components/SS7.jpeg";
import SS8Image from "./components/SS8.jpeg";
import SS9Image from "./components/SS9.jpeg";
import SS10Image from "./components/SS10.jpeg";
import SS11Image from "./components/SS11.jpeg";
import SS12Image from "./components/SS12.jpeg";
import SS13Image from "./components/SS13.jpeg";
import SS14Image from "./components/SS14.jpeg";
// NY images
import NY1Image from "./components/NY1.jpeg";
import NY2Image from "./components/NY2.jpeg";
import NY3Image from "./components/NY3.jpeg";
import NY4Image from "./components/NY4.jpeg";
import NY5Image from "./components/NY5.jpeg";
// F images
import F1Image from "./components/F1.jpeg";
import F2Image from "./components/F2.jpeg";
import F3Image from "./components/F3.jpeg";
import F4Image from "./components/F4.jpeg";
import F5Image from "./components/F5.jpeg";
import F6Image from "./components/F6.jpeg";
import F7Image from "./components/F7.jpeg";
import F8Image from "./components/F8.jpeg";
import F9Image from "./components/F9.jpeg";
import F10Image from "./components/F10.jpeg";
// L images
import L1Image from "./components/L1.jpeg";
import L2Image from "./components/L2.jpeg";
import L3Image from "./components/L3.jpeg";
import L4Image from "./components/L4.jpeg";
import L5Image from "./components/L5.jpeg";
import L6Image from "./components/L6.jpeg";
import L7Image from "./components/L7.jpeg";
import L8Image from "./components/L8.jpeg";

// World dimensions (4x resolution)
export const WORLD_W = 10000;
export const WORLD_H = 10000;
export const TILE_SIZE = 128; // Pokemon-style tile size (4x)

// Physics tuning (4x speeds to maintain same relative feel)
export const MAX_SPEED = 600;
export const ACCEL = 1680;
export const BRAKE = 2080;
export const FRICTION = 880;
export const TURN_RATE = 2.6;

// Car dimensions (6x bigger from original)
export const CAR_W = 234; // 39 * 6
export const CAR_H = 396; // 66 * 6

// Camera zoom (lower = more zoomed out, shows more area)
export const CAMERA_ZOOM = 0.27; // 0.6 means showing 1/0.6 = 1.67x more area

// Decorative objects
export const NUM_TREES = 200;
export const NUM_ROCKS = 100;
export const NUM_DECORATIVE_GRASS = 200;
export const NUM_FLOWERS = 150;

// Initial car position (4x)
export const INITIAL_CAR_X = 500;
export const INITIAL_CAR_Y = 500;

// Starting line flag (special flag before the first regular flag)
export const STARTING_LINE_INDEX = -1;
export const STARTING_LINE_POSITION: Building = { x: 1500, y: 1500 }; // Near starting position
export const STARTING_LINE_TEXT = "I decided to mix it up a bit this year :) it was fun making this and I’m so happy for all the memories we’ve made. I had to omit a lot of pictures because I was shirtless hahaha. But I still included a lot of good ones of you hehe. Still can’t believe we met that fateful day at Westwood and we’ve grown so much since then. I can’t wait for many many more years of adventures with you. Stay tuned for the next website drop ❤️";

// Hardcoded flag locations - easy to add more by just adding { x, y } entries
export const BUILDINGS: Building[] = [
  { x: 3900, y: 2000 },   // Washington DC
  { x: 6800, y: 1000 },   // Santa Cruz
  { x: 9000, y: 1500 },   // Pacifica
  { x: 8000, y: 3200 },   // Valentines
  { x: 6200, y: 4000 },   // Me and you <3
  { x: 4200, y: 4200 },   // Tahoe
  { x: 1500, y: 3400 },   // Coachella
  { x: 1000, y: 5200 },   // SF Fun!
  { x: 3000, y: 6400 },   // Hawaii
  { x: 5400, y: 5800 },   // Lassen National Park
  { x: 7500, y: 5300 },   // Food yum
  { x: 9500, y: 5900 },   // Crater Lake
  { x: 8500, y: 8200 },   // SF Fun Part 2!
  { x: 6000, y: 9200 },   // Birthday girl
  { x: 4300, y: 8400 },   // New York City
  { x: 1900, y: 9200 },   // Japan
];

// Dates for each flag (MM-DD-YYYY format) - add one date per building above
// Make sure FLAG_DATES has at least as many entries as BUILDINGS
export const FLAG_DATES = [
  "01-02-2025", // Washington DC
  "01-19-2025", // Santa Cruz
  "01-25-2025", // Pacifica
  "02-14-2025", // Valentines
  "Me and you <3", // Me and you <3
  "03-25-2025", // Tahoe
  "04-12-2025", // Coachella
  "SF Fun!", // SF Fun!
  "05-25-2025", // Hawaii
  "07-05-2025", // Lassen National Park
  "Food yum", // Food
  "08-30-2025", // Crater Lake
  "SF Fun Part 2!", // SF Fun Part 2!
  "09-07-2025", // Birthday girl
  "09-20-2025", // New York City
  "12-27-2025", // Japan
];

export const FLAG_TITLES = [
  "Washington D.C.",
  "Santa Cruz",
  "Pacifica",
  "Valentine's Day!",
  "Me and you <3", // Me and you <3
  "Tahoe",
  "Coachella",
  "SF Fun!",
  "Hawaii",
  "Lassen National Park",
  "Food yum",
  "Crater Lake National Park",
  "SF Fun Part 2!",
  "Birthday girl",
  "New York City",
  "Japan"
]

// Media files for each flag (images and videos)
export type MediaItem = {
  src: string;
  type: 'image' | 'video';
};

// Media configuration for each flag
// Index corresponds to building index (0 = Flag 1, 1 = Flag 2, etc.)
export const FLAG_MEDIA: MediaItem[][] = [
  // Washington DC
  [
    { src: W1Image, type: 'image' },
    { src: W2Image, type: 'image' },
    { src: W3Image, type: 'image' },
    { src: W4Image, type: 'image' },
    { src: W5Image, type: 'image' },
  ],
  // Santa Cruz
  [
    { src: SC1Image, type: 'image' },
    { src: SC2Image, type: 'image' },
    { src: SC3Video, type: 'video' },
  ],
  // Pacifica
  [
    { src: P1Image, type: 'image' },
    { src: P2Image, type: 'image' },
    { src: P3Video, type: 'video' },
    { src: P4Image, type: 'image' },
    { src: P5Image, type: 'image' },
    { src: P6Image, type: 'image' },
  ],
  // Valentine's Day!
  [
    { src: V1Image, type: 'image' },
    { src: V2Image, type: 'image' },
    { src: V3Image, type: 'image' },
    { src: V4Image, type: 'image' },
  ],
  // Me and you <3
  [
    { src: R1Image, type: 'image' },
    { src: R2Image, type: 'image' },
    { src: R3Image, type: 'image' },
    { src: R4Image, type: 'image' },
    { src: R5Image, type: 'image' },
    { src: R6Image, type: 'image' },
    { src: R7Image, type: 'image' },
    { src: R8Image, type: 'image' },
  ],
  // Tahoe
  [
    { src: T1Image, type: 'image' },
    { src: T2Image, type: 'image' },
    { src: T3Image, type: 'image' },
    { src: T4Image, type: 'image' },
    { src: T5Image, type: 'image' },
    { src: T6Image, type: 'image' },
  ],
  // Coachella
  [
    { src: C1Image, type: 'image' },
    { src: C2Image, type: 'image' },
    { src: C3Image, type: 'image' },
    { src: C4Image, type: 'image' },
  ],
  // SF Fun!
  [
    { src: SF1Image, type: 'image' },
    { src: SF2Image, type: 'image' },
    { src: SF3Image, type: 'image' },
    { src: SF4Image, type: 'image' },
    { src: SF5Image, type: 'image' },
    { src: SF6Image, type: 'image' },
    { src: SF7Image, type: 'image' },
    { src: SF8Image, type: 'image' },
    { src: SF9Image, type: 'image' },
    { src: SF10Image, type: 'image' },
  ],
  // Hawaii
  [
    { src: H1Image, type: 'image' },
    { src: H2Image, type: 'image' },
    { src: H3Image, type: 'image' },
    { src: H4Image, type: 'image' },
    { src: H5Image, type: 'image' },
    { src: H6Image, type: 'image' },
    { src: H7Image, type: 'image' },
    { src: H8Image, type: 'image' },
    { src: H9Image, type: 'image' },
    { src: H10Image, type: 'image' },
    { src: H11Video, type: 'video' },
  ],
  // Lassen National Park
  [
    { src: L1Image, type: 'image' },
    { src: L2Image, type: 'image' },
    { src: L3Image, type: 'image' },
    { src: L4Image, type: 'image' },
    { src: L5Image, type: 'image' },
    { src: L6Image, type: 'image' },
    { src: L7Image, type: 'image' },
    { src: L8Image, type: 'image' },
  ],
  // Food yum
  [
    { src: F1Image, type: 'image' },
    { src: F2Image, type: 'image' },
    { src: F3Image, type: 'image' },
    { src: F4Image, type: 'image' },
    { src: F5Image, type: 'image' },
    { src: F6Image, type: 'image' },
    { src: F7Image, type: 'image' },
    { src: F8Image, type: 'image' },
    { src: F9Image, type: 'image' },
    { src: F10Image, type: 'image' },
  ],
  // Crater Lake National Park
  [
    { src: CL1Image, type: 'image' },
    { src: CL2Image, type: 'image' },
    { src: CL3Image, type: 'image' },
    { src: CL4Image, type: 'image' },
    { src: CL5Image, type: 'image' },
    { src: CL6Image, type: 'image' },
    { src: CL7Image, type: 'image' },
    { src: CL8Image, type: 'image' },
    { src: CL9Image, type: 'image' },
    { src: CL10Image, type: 'image' },
    { src: CL11Image, type: 'image' },
    { src: CL12Image, type: 'image' },
    { src: CL13Video, type: 'video' },
    { src: CL14Image, type: 'image' },
    { src: CL15Image, type: 'image' },
    { src: CL16Image, type: 'image' },
    { src: CL17Image, type: 'image' },
  ],
  // SF Fun Part 2!
  [
    { src: SS1Image, type: 'image' },
    { src: SS2Image, type: 'image' },
    { src: SS3Image, type: 'image' },
    { src: SS4Image, type: 'image' },
    { src: SS5Image, type: 'image' },
    { src: SS6Image, type: 'image' },
    { src: SS7Image, type: 'image' },
    { src: SS8Image, type: 'image' },
    { src: SS9Image, type: 'image' },
    { src: SS10Image, type: 'image' },
    { src: SS11Image, type: 'image' },
    { src: SS12Image, type: 'image' },
    { src: SS13Image, type: 'image' },
    { src: SS14Image, type: 'image' },
  ],
  // Birthday girl
  [
    { src: B1Image, type: 'image' },
    { src: B2Image, type: 'image' },
    { src: B3Image, type: 'image' },
    { src: B4Image, type: 'image' },
    { src: B5Image, type: 'image' },
    { src: B6Image, type: 'image' },
    { src: B7Image, type: 'image' },
  ],
  // New York
  [
    { src: NY1Image, type: 'image' },
    { src: NY2Image, type: 'image' },
    { src: NY3Image, type: 'image' },
    { src: NY4Image, type: 'image' },
    { src: NY5Image, type: 'image' },
  ],
];

// Flag dimensions (all flags are the same size)
// Flag: 240px wide, 160px tall triangle, pole is 400px tall
export const FLAG_WIDTH = 240;
export const FLAG_HEIGHT = 160;
export const FLAG_POLE_HEIGHT = 400;
export const FLAG_POLE_WIDTH = 16;
export const FLAG_OFFSET = 40; // Distance from top of pole

// Heart area (2x)
export const HEART_TILE_SIZE = 15; // Same tile count, but tiles are 2x bigger
export const HEART_START_TILE_Y = 25; // Same tile position

// Heart outline positions (relative to heart area start, 15x15 grid)
export const HEART_OUTLINE_TILES: Array<[number, number]> = [
  // Top row - left and right bumps
  [3, 0], [4, 0], [5, 0], [9, 0], [10, 0], [11, 0],
  
  // Row 1 - expanding bumps
  [2, 1], [3, 1], [5, 1], [6, 1], [8, 1], [9, 1], [11, 1], [12, 1],
  
  // Row 2 - wider bumps
  [1, 2], [2, 2], [6, 2], [7, 2], [8, 2], [12, 2], [13, 2],
  
  // Row 3 - connecting
  [0, 3], [1, 3], [7, 3], [13, 3], [14, 3],
  
  // Row 4 - sides
  [0, 4], [14, 4],
  
  // Row 5 - sides
  [0, 5], [14, 5],
  
  // Row 6 - coming together
  [1, 6], [1, 5], [2, 6], [13, 6], [12, 6], [13, 5],
  
  // Row 7 - narrowing
  [2, 7], [3, 7], [11, 7], [12, 7],
  
  // Row 8 - more narrowing
  [3, 8], [4, 8], [10, 8], [11, 8],
  
  // Row 9 - center connection
  [4, 9], [5, 9], [9, 9], [10, 9],
  
  // Row 10 - bottom widening
  [5, 10], [6, 10], [8, 10], [9, 10],
  
  // Row 11 - narrowing to point
  [6, 11], [7, 11], [8, 11],
  
  // Row 12 - point
  [7, 12],
];

// Collision detection (4x)
export const COLLISION_PADDING = 80;

// Pond (tiled, like grass) (4x)
export const POND_TILE_SIZE = 10; // Same tile count, but tiles are 4x bigger
export const POND_CENTER_X = 6000; // Right middle of screen (4x)
export const POND_CENTER_Y = 4000; // Middle of world height (4x)

// Path generation (4x)
// PATH_WIGGLE_CHANCE and PATH_WIGGLE_DISTANCE are no longer used
// Paths now use control points with large curves
export const PATH_WIGGLE_VARIANCE = 500; // Large variance for big curves (wider deviation from straight line)
export const PATH_WIDTH = 120; // pixels (4x)

// Object generation
export const MAX_PLACEMENT_ATTEMPTS = 1000;
export const TREE_COLLISION_RADIUS = 80;
export const ROCK_COLLISION_RADIUS = 72;
export const DECORATIVE_GRASS_COLLISION_RADIUS = 60;
export const FLOWER_COLLISION_RADIUS = 50;

// Flag date text dimensions
export const DATE_TEXT_HEIGHT = 96; // Font size
export const DATE_TEXT_WIDTH = 400; // Estimated width for date text
export const DATE_TEXT_OFFSET = 250; // Distance below flag

// Animation constants
export const ANIMATION_DURATION = 2000; // 2 seconds of animation
export const MAX_WIGGLE_ANGLE = 0.15; // Max rotation in radians (~8.6 degrees)

// Snowflake constants
export const NUM_SNOWFLAKES = 1500;
export const SNOWFLAKE_MIN_SIZE = 1;
export const SNOWFLAKE_MAX_SIZE = 4;
export const SNOWFLAKE_MIN_SPEED = 20;
export const SNOWFLAKE_MAX_SPEED = 80;
export const SNOWFLAKE_DRIFT_RANGE = 20;
export const SNOWFLAKE_MIN_OPACITY = 0.5;
export const SNOWFLAKE_MAX_OPACITY = 1.0;
export const SNOWFLAKE_MIN_LIFETIME = 3000; // 3 seconds
export const SNOWFLAKE_MAX_LIFETIME = 10000; // 10 seconds
export const SNOWFLAKE_FADE_TIME = 500; // Fade out over last 500ms

// UI constants
export const FLAG_COUNTER_PADDING = 20;
export const FLAG_COUNTER_ICON_SIZE = 32;
export const FLAG_COUNTER_ICON_PADDING = 12;
export const FLAG_COUNTER_TEXT_PADDING = 8;
export const FLAG_COUNTER_FONT_SIZE = 32;
export const FLAG_COUNTER_BG_COLOR = "#4a90e2";
export const FLAG_COUNTER_CORNER_RADIUS = 8;

// Colors
export const COLORS = {
  GRASS_BASE: "#78c850",
  GRASS_DARK: "#6ab83d",
  GRASS_DARKER: "#5a9a2f",
  DIRT_BASE: "#8b7355",
  DIRT_DARK: "#6b5d47",
  DIRT_LIGHT: "#a0826d",
  HEART_RED: "#ff0000",
  HEART_DARK_RED: "#cc0000",
  HEART_BORDER: "#990000",
  CAR_BODY: "#1f2937",
  CAR_WINDOW: "#60a5fa",
} as const;

